export * from './rbac.service';
import { RbacService } from './rbac.service';
export * from './substitute.service';
import { SubstituteService } from './substitute.service';
export * from './userProfile.service';
import { UserProfileService } from './userProfile.service';
export const APIS = [RbacService, SubstituteService, UserProfileService];
